<template>
  <div class="password-popup-overlay" v-if="visible" @click.self="close">
    <div class="password-popup-content">
      <div class="password-popup-card">
        <div class="password-popup-title">输入密码</div>
        <div class="password-popup-label">
          <span>提现密码</span>
          <img class="password-popup-eye" src="/static/newImg/withdraw/icon_eye.svg" @click="showPassword = !showPassword" />
        </div>
        <div class="password-popup-inputs">
          <div class="password-popup-input-item" v-for="i in 6" :key="i" :class="{ active: i === password.length + 1 }">
            <span v-if="password.length >= i" :class="{ dot: !showPassword }">{{ showPassword ? password[i - 1] : '' }}</span>
            <span v-else-if="i === password.length + 1" class="cursor"></span>
          </div>
        </div>
        <div class="password-popup-tip">
          <span>为了您的账户安全，请输入提现密码</span>
          <span class="password-popup-forgot">忘记密码?</span>
        </div>
        <div class="password-popup-btn" :class="{ disabled: password.length < 6 }" @click="onNext">下一步</div>
      </div>
      <div class="password-popup-close" @click="close">
        <svg viewBox="0 0 24 24" width="32" height="32">
          <circle cx="12" cy="12" r="10" fill="none" stroke="#fff" stroke-width="1.5"/>
          <line x1="8" y1="8" x2="16" y2="16" stroke="#fff" stroke-width="1.5"/>
          <line x1="16" y1="8" x2="8" y2="16" stroke="#fff" stroke-width="1.5"/>
        </svg>
      </div>
      <div class="password-keyboard">
        <div class="password-keyboard-row">
          <div class="password-key" v-for="n in [1,2,3]" :key="n" @click="onKey(n)">{{ n }}</div>
        </div>
        <div class="password-keyboard-row">
          <div class="password-key" v-for="n in [4,5,6]" :key="n" @click="onKey(n)">{{ n }}</div>
        </div>
        <div class="password-keyboard-row">
          <div class="password-key" v-for="n in [7,8,9]" :key="n" @click="onKey(n)">{{ n }}</div>
        </div>
        <div class="password-keyboard-row">
          <div class="password-key password-key-empty">
            <svg viewBox="0 0 24 24" width="22" height="22">
              <rect x="2" y="4" width="20" height="16" rx="2" fill="none" stroke="#fff" stroke-width="1.5"/>
              <line x1="6" y1="8" x2="10" y2="8" stroke="#fff" stroke-width="1.5"/>
              <line x1="6" y1="12" x2="14" y2="12" stroke="#fff" stroke-width="1.5"/>
              <line x1="6" y1="16" x2="12" y2="16" stroke="#fff" stroke-width="1.5"/>
            </svg>
          </div>
          <div class="password-key" @click="onKey(0)">0</div>
          <div class="password-key" @click="onBackspace">
            <svg viewBox="0 0 24 24" width="24" height="24">
              <path d="M22 3H7l-5 9 5 9h15V3z" fill="none" stroke="#fff" stroke-width="1.5"/>
              <line x1="14" y1="9" x2="18" y2="15" stroke="#fff" stroke-width="1.5"/>
              <line x1="18" y1="9" x2="14" y2="15" stroke="#fff" stroke-width="1.5"/>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PasswordPopup',
  props: {
    visible: { type: Boolean, default: false },
  },
  data() {
    return {
      password: '',
      showPassword: false,
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.password = '';
      }
    },
  },
  methods: {
    // 统一 toast：向上级联找 App.vue 的 showTost(type, msg)，不会被当前弹框遮罩挡住
    toast(msg, type = 0) {
      let p = this.$parent;
      while (p) {
        if (typeof p.showTost === 'function') {
          p.showTost(type, msg);
          return;
        }
        p = p.$parent;
      }
      if (this.$notify) {
        this.$notify({ type: type ? 'success' : 'danger', message: msg, zIndex: 999999, duration: 2500 });
        return;
      }
      if (this.$toast) {
        try { this.$toast({ message: msg, zIndex: 999999, position: 'top' }); } catch (_) { this.$toast(msg); }
        return;
      }
      this._domToast(msg);
    },
    _domToast(msg) {
      try {
        if (!msg) return;
        const el = document.createElement('div');
        el.textContent = msg;
        Object.assign(el.style, {
          position: 'fixed', top: '40%', left: '50%', transform: 'translateX(-50%)',
          background: 'rgba(0,0,0,0.78)', color: '#fff', padding: '0.24rem 0.35rem',
          borderRadius: '0.1rem', fontSize: '0.3rem', zIndex: '999999',
          maxWidth: '80%', textAlign: 'center', pointerEvents: 'none',
        });
        document.body.appendChild(el);
        setTimeout(() => { try { document.body.removeChild(el); } catch (_) {} }, 1500);
      } catch (_) {}
    },
    onKey(n) {
      if (this.password.length < 6) {
        this.password += String(n);
      }
    },
    onBackspace() {
      this.password = this.password.slice(0, -1);
    },
    onNext() {
      if (this.password.length < 6) {
        this.toast('请输入完整的6位提现密码');
        return;
      }
      this.$emit('submit', this.password);
    },
    clearInput() {
      this.password = '';
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.password-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 999;
}

.password-popup-content {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  z-index: 1000;
}

.password-popup-card {
  width: 92%;
  max-width: 360px;
  background: #1a1a1a;
  border-radius: 0.2rem;
  padding: 0.5rem 0.35rem 0.35rem;
}

.password-popup-title {
  text-align: center;
  font-size: 0.38rem;
  color: #fff;
  font-weight: bold;
  margin-bottom: 0.4rem;
}

.password-popup-label {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.32rem;
  color: #fff;
  margin-bottom: 0.2rem;
}

.password-popup-eye {
  width: 0.45rem;
  height: 0.45rem;
  cursor: pointer;
  opacity: 0.4;
}

.password-popup-inputs {
  display: flex;
  gap: 0.1rem;
  margin-bottom: 0.25rem;
}

.password-popup-input-item {
  flex: 1;
  height: 1.35rem;
  border: 1px solid #333;
  border-radius: 0.08rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.4rem;
  color: #fff;
  background: #000;
  position: relative;

  &.active {
    border-color: #DFB372;
  }

  .dot {
    width: 0.22rem;
    height: 0.22rem;
    background: #fff;
    border-radius: 50%;
  }

  .cursor {
    width: 2px;
    height: 0.35rem;
    background: #DFB372;
    animation: blink 1s infinite;
  }
}

@keyframes blink {
  0%, 50% { opacity: 1; }
  51%, 100% { opacity: 0; }
}

.password-popup-tip {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.28rem;
  color: #fff;
  margin-bottom: 0.3rem;
}

.password-popup-forgot {
  color: #DFB372;
  cursor: pointer;
  font-size: 0.35rem;
}

.password-popup-btn {
  width: 100%;
  text-align: center;
  padding: 0.25rem 0;
  margin-top: 0.5rem;
  background: #DFB372;
  color: #1a1a1a;
  border-radius: 0.1rem;
  font-size: 0.35rem;
  cursor: pointer;

  &.disabled {
    background: #5a5a5a;
    color: #999;
    cursor: not-allowed;
  }
}

.password-popup-close {
  margin-bottom: 0.5rem;
  cursor: pointer;
}

.password-keyboard {
  width: 100%;
  max-width: 380px;
  padding-bottom: 0.5rem;
}

.password-keyboard-row {
  display: flex;
  gap: 0.06rem;
  margin-bottom: 0.15rem;
}

.password-key {
  flex: 1;
  height: 1.5rem;
  background: #222;
  border-radius: 0.08rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.4rem;
  color: #fff;
  cursor: pointer;
  user-select: none;

  &:active {
    background: #333;
  }

  &-empty {
    background: #222;
    pointer-events: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/withdraw/PasswordPopup.vue